import React from "react";
import PropTypes from "prop-types";
import { Form, Input, TextArea } from "semantic-ui-react";
import Erro from "../../layouts/mensagens/Erro";
import { SecaoForm, AreaArquivo, AvisoForm } from "../../layouts/FormUI";

// Campos compartilhados entre o cadastro e a edição de notificação.
const CamposNotificacao = ({
  notificacao, file, errors, tipos, unidadesOpcoes, arquivoAtualUrl, modeloUrl,
  onChange, onChangeSelect, onChangeFile,
}) => {
  const todas = !notificacao.unidades || notificacao.unidades.length === 0;
  return (
    <>
      <SecaoForm icone="bell outline" titulo="Conteúdo" descricao="O que os moradores recebem no aplicativo.">
        <Form.Field error={!!errors.tipo} required>
          <Form.Select
            fluid
            label="Tipo de notificação"
            name="tipo"
            options={tipos}
            onChange={onChangeSelect}
            value={notificacao.tipo}
            placeholder="Selecione o tipo"
          />
          <Erro text={errors.tipo} />
        </Form.Field>
        <Form.Field error={!!errors.mensagem}>
          <label htmlFor="mensagem">Mensagem</label>
          <TextArea id="mensagem" name="mensagem" placeholder="Escreva a mensagem que será enviada" rows={4} onChange={onChange} value={notificacao.mensagem} />
          <Erro text={errors.mensagem} />
        </Form.Field>
        <Form.Field error={!!errors.link}>
          <label htmlFor="link">Link de acesso ou transmissão <small>(opcional)</small></label>
          <Input id="link" name="link" type="text" placeholder="Link do Zoom, YouTube, Meet, Teams, Skype..." onChange={onChange} value={notificacao.link || ""} />
          <Erro text={errors.link} />
        </Form.Field>
      </SecaoForm>

      <SecaoForm icone="paperclip" titulo="Anexo" descricao="Imagem ou documento PDF (opcional se houver mensagem).">
        <AreaArquivo
          id="arquivo"
          arquivo={file}
          accept="image/*,application/pdf"
          onChange={onChangeFile}
          icone="file outline"
          titulo={arquivoAtualUrl ? "Clique para trocar o anexo" : "Arraste o arquivo aqui ou clique para selecionar"}
          dica={`Imagem ou PDF · até ${process.env.REACT_APP_LIMIT_UPLOAD}mb`}
          erro={errors.arquivo}
          existenteUrl={arquivoAtualUrl}
          existenteTexto="Ver anexo atual"
        />
        {!!modeloUrl && (
          <p className="va-imp-dica">
            <a href={modeloUrl} target="_blank" rel="noopener noreferrer">Baixar o modelo padrão de edital de convocação (.docx)</a>
          </p>
        )}
      </SecaoForm>

      <SecaoForm icone="users" titulo="Destinatários">
        <Form.Field>
          <Form.Select
            fluid
            label="Unidades votantes"
            name="unidades"
            options={unidadesOpcoes}
            onChange={onChangeSelect}
            value={notificacao.unidades}
            placeholder="Todas as unidades votantes"
            multiple={true}
            search
          />
        </Form.Field>
        <AvisoForm tipo={todas ? "ok" : ""} icone={todas ? "check circle" : "info circle"}>
          {todas
            ? "Será enviada para todas as unidades votantes."
            : `Será enviada para ${notificacao.unidades.length} unidade${notificacao.unidades.length !== 1 ? "s" : ""} selecionada${notificacao.unidades.length !== 1 ? "s" : ""}.`}
        </AvisoForm>
      </SecaoForm>
    </>
  );
};

CamposNotificacao.propTypes = {
  notificacao: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  tipos: PropTypes.array.isRequired,
  unidadesOpcoes: PropTypes.array.isRequired,
};

export default CamposNotificacao;
